module.exports = __webpack_public_path__ + "img/icon-tag.450f9981.svg";